<ng-container *appTaskingAppContext>
<!--
  #998 iteration 3: tasking has no top bar. The page starts at y = 0, so this wrapper is tasking's
  own — `.under-nav-bar` is shared by the three layouts that still carry a 48 px `app-nav-bar`
  (contacts, notes, files) plus the three `app-base-nav-bar` ones (settings, admin, spaces), and
  must keep its offset for them.

  #1547: the rail's OWN split-view is gone, as notes' went in #1146 and mail's in round 1. It is a fixed
  266 px column now — no gutter, no drag, no magnetic width and no reopen chevron. The rail component
  owns its parked width; the host owns the docked one and passes it in the stylesheet.

  The TASKS LIST keeps its splitter, and keeps `[iconTop]="38"` with it, as `mail-layout`,
  `events-layout` and `layout.component.html` do: the reopen chevron's stylesheet default is
  `top: -10px` measured from the split-view's own top edge. Under the bar that edge sat at y = 48, so
  the chevron landed at 38 by accident of the bar (measured on this branch before the #998 edit:
  (66, 38)); from y = 0 the same default draws it half above the window.
-->
<div class="tasking-shell">
  <!--
    The shell sits OUTSIDE `*stchSpaceRerender` on purpose: the bell's subscription, the app switcher
    and the search input survive a workspace switch. Only the rail below is torn down and rebuilt.
  -->
  <app-collapsible-rail-shell class="tasking-rail" [app]="app">
    <stch-side-bar-teams
      *stchSpaceRerender
      [template]="sidebarTemplate"
      [splitViewKey]="SidebarSplitViewKey.tasking"
    />
  </app-collapsible-rail-shell>

  <app-split-view
    class="tasking-rest"
    side="left"
    key="tasksList"
    [collapsedSize]="25"
    [shadow]="true"
    [magneticSize]="300"
    [withIcon]="true"
    [iconTop]="38"
  >
    <app-tasks-list-container
      split-left-pane
      *stchSpaceRerender
      class="list shadow-lg"
    />

    <div
      class="full-form shadow-lg"
      split-right-pane
    >
      <app-tasks-main-view *stchSpaceRerender />
    </div>
  </app-split-view>

  <ng-template #sidebarTemplate let-team="team">
    <app-tasks-side-bar [team]="team"/>
  </ng-template>
</div>
</ng-container>
